import { render, staticRenderFns } from "./PendingInvitations.vue?vue&type=template&id=d78d9e42&scoped=true"
import script from "./PendingInvitations.vue?vue&type=script&lang=js"
export * from "./PendingInvitations.vue?vue&type=script&lang=js"
import style0 from "./PendingInvitations.vue?vue&type=style&index=0&id=d78d9e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78d9e42",
  null
  
)

export default component.exports